import { Foundation } from '@models';

export interface FoundationResult {
  foundation: Foundation;
}
